<template>
    <section class="content">
        <div class="row center-block">
            <!--<h2>Data tables</h2>-->
            <div class="col-md-12">
                <div class="box">
                    <!--<div class="box-header">-->
                        <!--<h3 class="box-title">店家拆帳列表</h3>-->
                    <!--</div>-->
                    <!-- /.box-header -->
                    <div class="box-body">
                        <history-table />
                        <!-- /.box-body -->
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
// Require needed datatables modules
import 'datatables.net'
import 'datatables.net-bs'
import historyTableTemp from './Temp/HistoryTableTemp'
export default {
  name: 'Tables',
  data () {
    return {
      tableIndex: 1
    }
  },
  mounted () {
  },
  methods: {
    isActive (index) {
      if (this.tableIndex === index) return true
      else return false
    }
  },
  components: {
    'history-table': historyTableTemp
  },
  computed: {
    getDataH () {
      return this.$parent.getDataH
    },
    getFile () {
      return this.$parent.getFile
    }
  }
}
</script>



// WEBPACK FOOTER //
// OneStoreHistoryTable.vue?76247f62